import { Dispatch } from 'redux';

import * as SkillMapDetailActions from '../actions/skillMapDetail';
import AbstractScenario from './AbstractScenario';

export default class SkillMapDetailScenarioFactory {
	/**
	 * スキルマップ詳細情報画面初期化データ取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchSkillMapDetail(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(skillMapId: string) {
				// 初期化
				this.dispatch(
					SkillMapDetailActions.setSkillMapDetail({
						skillMapInfo: {
							skillMapId: '',
						},
					})
				);

				// データ取得
				const doScenario = SkillMapDetailScenarioFactory.createDoFetchSkillMapDetail(
					this.dispatch,
					this.token
				);
				return doScenario.run(skillMapId).then(data => {
					this.dispatch(
						SkillMapDetailActions.setSkillMapDetail(data)
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * スキルマップ情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createDoFetchSkillMapDetail(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(skillMapId: string) {
				const param = {
					accessType: 10,
					skillMapId,
				};
				return this.read(
					'com_skill_SkillMapInfoDetailBlockModel',
					param
				).then(data => ({
					skillMapInfo: data as SkillMapDetailActions.ISkillMapDetail,
				}));
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/SkillMapDetailScenarioFactory.ts